import React, { ReactNode, FCC } from 'react';
import { IWizardStepProps } from './types';
import { WizardStep } from './WizardStep';

export interface IWizardStaticStepProps extends IWizardStepProps {
  children: ReactNode;
}

export const WizardStaticStep: FCC<IWizardStaticStepProps> = (props) => {
  return (
    <WizardStep {...props} type={'static'}>
      {props.children}
    </WizardStep>
  );
};

export default WizardStaticStep;
